import { MEMBERSHIP_MODULE } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { IMembershipUsageDetailsResponse } from "@/api_framework/api_modals/Membership";
import { useAPIUtils } from "../../useAPIUtils";
import { setMembershipUsageDetails } from "@/app_redux/reducers/slices/auth/membership.slice";

AxiosCurlirize(axios, () => {});

export const useMembershipUsageDetailsAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (user_id: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .get(`${MEMBERSHIP_MODULE?.MEMBERSHIP_USAGE?.baseURL}${user_id}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IMembershipUsageDetailsResponse>) => {
            if (res.data.status) {
              dispatch(setMembershipUsageDetails({ data: res.data.data }));
            } else {
              dispatch(setMembershipUsageDetails({ data: null }));
            }
          })
          .catch((e: AxiosError) => {
            dispatch(setMembershipUsageDetails({ data: null }));
            sendCurl(e.config["curlCommand"]);
            if (e.code === "ERR_BAD_REQUEST") {
              //   toast.error("Error while fetching List details");
            }
            if (e.status === 400) {
              //   toast("Product records not found");
            }

            if (e.response.status === 500) {
              toast.error("Server error 500");
            }
          });
      } catch (e: any) {
        captureError(e);
        dispatch(setMembershipUsageDetails({ data: null }));
      }
    },
    [dispatch],
  );
  return { execute };
};
